module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheLogo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TheLogo__title"
  }, [_vm._v("\n        " + _vm._s(_vm.appFirstWord)), _c('span', {
    staticClass: "TheLogo__color"
  }, [_vm._v(_vm._s(_vm.appSecondWord))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheLogo__icon"
  }, [_c('img', {
    staticClass: "TheLogo__image",
    attrs: {
      "src": "static/images/icons/android-icon-144x144.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc7d12e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TheLogo.vue
// module id = 485
// module chunks = 1